import React from "react";
import { createRoot } from "react-dom/client";
import ConversationList from "../features/conversation-list/conversation-list";

export default class ConversationListWebComponent extends HTMLElement {
	root = createRoot(this);

	connectedCallback() {
		this.render();
	}

	render() {
		const customer = this.getCustomerFromAttributes();
		const numberOfConversationsPerLoad =
			parseInt(
				this.getAttribute("number-of-conversations-per-load") || "",
				10,
			) || 100;
		const enableSecureMessagingRedesignParam = this.getAttribute(
			"enable-secure-messaging-redesign",
		);
		const isSecureMessagingRedesignEnabled =
			enableSecureMessagingRedesignParam !== null &&
			enableSecureMessagingRedesignParam.toLowerCase() === "true";
		const emptyListMessage = this.getAttribute("empty-list-message");

		this.root.render(
			<ConversationList
				customer={customer}
				numberOfConversationsPerLoad={numberOfConversationsPerLoad}
				isSecureMessagingRedesignEnabled={isSecureMessagingRedesignEnabled}
				emptyListMessage={emptyListMessage}
			/>,
		);
	}

	getCustomerFromAttributes() {
		const tokenKey = this.getAttribute("token-key");
		const token = tokenKey ? window.sessionStorage.getItem(tokenKey) : null;
		const baseUrl = this.getAttribute("secure-messaging-proxy-base-url");
		const personId = this.getAttribute("person-id");
		const isInternalUserAttribute = this.getAttribute("is-internal-user");

		const cultureCode = this.getAttribute("culture-code");
		const name = this.getAttribute("customer-name");
		return {
			token,
			tokenKey,
			baseUrl,
			personId,
			isInternalUser:
				isInternalUserAttribute !== null &&
				isInternalUserAttribute.toLowerCase() === "true",
			cultureCode,
			name,
		};
	}
}
